export default __webpack_public_path__ + "static/media/feature-emp-6.2a93df80.png";